var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIcPlaystationActive = function SvgIcPlaystationActive(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "ic-playstation-active_svg__ic-playstation-active",
    viewBox: "0 0 32 32"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#DE0029",
    d: "M17.228 5.067l-.021 19.186-5.14-1.672V.03l6.561 1.735c4.2 1.128 6.77 3.323 6.729 7.168-.042 4.473-2.111 6.27-6.144 5.1v-8.82c0-1.066-1.985-1.128-1.985-.146z",
    transform: "translate(0 4)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F3C202",
    d: "M9.705 18.86l-2.424.816c-1.567.543-2.905-.732-1.463-1.255l1.17-.417-4.409-1.4c-1.358.46-2.633 1.441-2.55 2.82.084 1.401 3.281 1.736 5.747 2.133 2.299.376 4.389.167 6.29-.502v-1.442l-2.36-.753zm7.544 5.393l4.493-1.568-4.535-1.442v2.905l.042.105z",
    transform: "translate(0 4)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#326DB3",
    d: "M29.202 20.052l.083-.021c1.964-.69 2.8-1.651 2.592-2.55-.335-1.504-2.738-2.32-6.437-2.591-2.654-.188-5.266.397-7.815 1.274l-.418.147 4.576 1.421 2.675-.899c2.8-.522 3.929.397 1.233 1.254l-1.337.46 4.848 1.505zm-17.135-6.646l-2.028.69 2.028.626v-1.316z",
    transform: "translate(0 4)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00AA9E",
    d: "M21.742 22.685l7.46-2.633-4.848-1.505-7.147 2.445v.251l4.535 1.442zm-9.675-4.619l-2.362.794 2.362.753v-1.547zm5.14 1.234v-2.99l4.576 1.422-4.576 1.568zM6.988 18.004l5.078-1.819v-1.463l-2.027-.627-7.355 2.488c-.021 0-.063.02-.105.02l4.41 1.4z",
    transform: "translate(0 4)"
  }))));
};
export default SvgIcPlaystationActive;